// import React, { useEffect, useState } from "react";
// import { IconCreditCard, IconBrandVisa, IconCurrencyDollar } from "@tabler/icons-react";
// import {
//   Form,
//   Row,
//   Col,
//   InputGroup,
//   Card,
//   Button,
//   Modal,
// } from "react-bootstrap";
// import { Controller, FormProvider, useForm } from "react-hook-form";
// import usePostRequest from "../../hooks/usePostRequest";
// import { API_ENDPOINTS } from "../../constant/_constant";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as Yup from "yup";
// import Spinner from "react-bootstrap/Spinner";
// import { toast } from "react-toastify";
// import { useSelector } from "react-redux";

// // Validation Schema (same logic as LinkCard)
// const validationSchema = Yup.object().shape({
//   cardHolderName: Yup.string()
//     .required("Cardholder name is required")
//     .matches(/^[A-Za-z\s]+$/, "Only letters and spaces allowed"),
//   cardNumber: Yup.string()
//     .required("Card number is required")
//     .matches(/^\d{15,16}$/, "Card number must be 15 or 16 digits"),
//   expiry: Yup.string()
//     .required("Expiry is required")
//     .length(4, "Must be exactly 4 digits")
//     .test("valid-expiry", "Invalid month (01-12)", (value) => {
//       if (!/^\d{4}$/.test(value)) return false;
//       const month = parseInt(value.slice(0, 2), 10);
//       return month >= 1 && month <= 12;
//     }),
//   cvc: Yup.string()
//     .nullable()
//     .notRequired()
//     .test("cvc-format", "CVC must be 3 or 4 digits", (value) => {
//       if (!value) return true; // allow empty
//       return /^\d{3,4}$/.test(value);
//     }),
//   address: Yup.string().nullable().notRequired(),

//   // cvc: Yup.string()
//   //   .required("CVC is required")
//   //   .matches(/^\d{3,4}$/, "CVC must be 3 or 4 digits"),
//   zipCode: Yup.string()
//     .required("ZIP Code is required")
//     .matches(/^\d{5,9}$/, "ZIP code must be 5–9 digits"),
//   invoiceNumber: Yup.string().required("Invoice Number is required"),
//   amount: Yup.number()
//     .typeError("Amount must be a number")
//     .required("Amount is required")
//     .positive("Amount must be greater than zero"),
//   notes: Yup.string().optional(),
// });

// function CustomerCardEdit({ show, onClose, formData }) {
//   const methods = useForm({
//     resolver: yupResolver(validationSchema),
//     mode: "onChange",
//     defaultValues: {
//       cardHolderName: "",
//       cardNumber: "",
//       expiry: "",
//       cvc: "",
//       zipCode: "",
//       invoiceNumber: "",
//       amount: "",
//       notes: "",
//       address: "",
//     },
//   });

//   const user = useSelector((state) => state.auth.user);
//   const allowedRoles = ["finance"];
//   const canViewFinancials = user?.roles?.some((role) =>
//     allowedRoles.includes(role),
//   );

//   const {
//     control,
//     handleSubmit,
//     setValue,
//     watch,
//     formState: { errors, isSubmitting },
//     reset,
//   } = methods;

//   const { isLoading, postData: submitCardDetails } = usePostRequest(
//     API_ENDPOINTS.UPDATE_CARD_DETAILS
//   );

//   const expiryValue = watch("expiry");
//   // console.log("expiryValue", expiryValue);

//   const [cardId, setCardId] = useState(null);
//   const [otp, setotp] = useState(null);

//   useEffect(() => {
//     if (show && formData) {
//       console.log("Prefilling form:", formData);
//       setCardId(formData.id || null);
//       setotp(formData.otp || null);
//       setValue("cardHolderName", formData.data?.info_name || "");
//       setValue("cardNumber", formData.data?.info_number || "");

//       let expiry = formData.data?.info_expiry || "";
//       if (expiry.includes("/")) {
//         expiry = expiry.replace("/", ""); // Remove "/" to normalize to MMYY
//       }

//       setValue("expiry", expiry);
//       setValue("cvc", formData.data?.cvc_code || "");

//       setValue("zipCode", formData?.data?.zip_code);

//       setValue("invoiceNumber", formData.data?.invoice_number || "");
//       setValue("amount", formData.data?.amount || "");

//       setValue("notes", formData.data?.note || "");
//       setValue("address", formData.data?.address || "");
//     }
//   }, [show, formData, setValue]);

//   // Helper to convert "1225" → "12/25"
//   const formatExpiry = (expiry) => {
//     if (!expiry || expiry.length < 4) return "";
//     const month = expiry.slice(0, 2);
//     const year = expiry.slice(2);
//     return `${month}/${year}`;
//   };

//   const handleCancel = () => {
//     reset();
//     onClose();
//   };

//   const onSubmit = (data) => {
//     console.log("Form Submitted:", data);

//     const apiData = {
//       id: cardId,
//       info_number: data.cardNumber.replace(/\D/g, ""),
//       info_expiry: data.expiry.replace("/", ""),
//       info_name: data.cardHolderName,
//       cvc_code: data.cvc || null,
//       otp: otp,
//       zip_code: data.zipCode,
//       invoice_number: data.invoiceNumber,
//       amount: data.amount,
//       note: data.notes || null,
//       address: data.address || null,
//     };

//     // Call the API to update the card details
//     submitCardDetails(apiData, onSuccessApi, onErrorApi);
//   };

//   const onSuccessApi = (res) => {
//     toast.success(res?.message);
//     onClose();
//   };

//   const onErrorApi = (err) => {
//     toast.error(err?.message);
//   };

//   return (
//     <Modal
//       show={show}
//       onHide={handleCancel}
//       centered
//       size="lg"
//       scrollable
//       dialogClassName="modal-90w"
//     >
//       <Modal.Header
//         closeButton
//         className="d-flex flex-column gap-2 justify-content-between pe-5 align-items-start"
//       >
//         <div className="d-flex align-items-center gap-2">
//           <span className="avatar bg-indigo-lt rounded-circle">
//             <IconCreditCard />
//           </span>
//           <Modal.Title>Update Customer Card Details</Modal.Title>
//         </div>
//         <p className="text-muted">
//           You have 2 minutes to submit the form before the OTP expires.
//         </p>
//       </Modal.Header>

//       <Modal.Body>
//         <Row className="justify-content-center">
//           <Col md={11}>
//             <Card className="add_credit_card mb-3">
//               <Card.Header className="card_header">UPDATE CARD</Card.Header>
//               <Card.Body>
//                 <FormProvider {...methods}>
//                   {/* <Form onSubmit={handleSubmit(onSubmit)}> */}
//                   <Form>
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Label className="required">
//                             CARDHOLDER NAME
//                           </Form.Label>
//                           <Controller
//                             name="cardHolderName"
//                             control={control}
//                             render={({ field }) => (
//                               <Form.Control
//                                 {...field}
//                                 placeholder="Enter Cardholder Name"
//                                 isInvalid={!!errors.cardHolderName}
//                               />
//                             )}
//                           />
//                           {errors.cardHolderName && (
//                             <div className="text-danger small">
//                               {errors.cardHolderName.message}
//                             </div>
//                           )}
//                         </Form.Group>
//                       </Col>

//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Label className="required">
//                             CARD NUMBER
//                           </Form.Label>
//                           <InputGroup>
//                             <InputGroup.Text>
//                               <IconBrandVisa stroke={1} />
//                             </InputGroup.Text>
//                             <Controller
//                               name="cardNumber"
//                               control={control}
//                               render={({
//                                 field: { onChange, value, ...field },
//                               }) => {
//                                 const digits = (value || "")
//                                   .replace(/\D/g, "")
//                                   .slice(0, 16);

//                                 const formatted = digits
//                                   .replace(/(.{4})/g, "$1 ")
//                                   .trim();

//                                 return (
//                                   <Form.Control
//                                     {...field}
//                                     value={formatted}
//                                     onChange={(e) => {
//                                       const digits = e.target.value
//                                         .replace(/\D/g, "")
//                                         .slice(0, 16); // ✅ allow up to 16 digits

//                                       onChange(digits); // store raw digits in form state
//                                     }}
//                                     placeholder="**** **** **** ****"
//                                     isInvalid={!!errors.cardNumber}
//                                   />
//                                 );
//                               }}
//                             />
//                           </InputGroup>
//                           {errors.cardNumber && (
//                             <div className="text-danger small">
//                               {errors.cardNumber.message}
//                             </div>
//                           )}
//                         </Form.Group>
//                       </Col>

//                       <Col md={4}>
//                         <Form.Group className="mb-3">
//                           <Form.Label className="required">EXPIRY</Form.Label>
//                           <Controller
//                             name="expiry"
//                             control={control}
//                             render={({
//                               field: { onChange, value, ...field },
//                             }) => {
//                               const clean = (value || "")
//                                 .replace(/\D/g, "")
//                                 .slice(0, 4);
//                               const formatted =
//                                 clean.length >= 3
//                                   ? `${clean.slice(0, 2)}/${clean.slice(2)}`
//                                   : clean;

//                               return (
//                                 <Form.Control
//                                   {...field}
//                                   value={formatted}
//                                   onChange={(e) =>
//                                     onChange(
//                                       e.target.value
//                                         .replace(/\D/g, "")
//                                         .slice(0, 4),
//                                     )
//                                   }
//                                   placeholder="MM/YY"
//                                   maxLength={5}
//                                   isInvalid={!!errors.expiry}
//                                 />
//                               );
//                             }}
//                           />
//                           {errors.expiry && (
//                             <div className="text-danger small">
//                               {errors.expiry.message}
//                             </div>
//                           )}
//                         </Form.Group>
//                       </Col>

//                       <Col md={4}>
//                         <Form.Group className="mb-3">
//                           <Form.Label className="">CVC CODE</Form.Label>
//                           <Controller
//                             name="cvc"
//                             control={control}
//                             render={({ field }) => (
//                               <Form.Control
//                                 {...field}
//                                 type={canViewFinancials ? "text" : "password"}
//                                 placeholder="123"
//                                 maxLength={4}
//                                 onChange={(e) =>
//                                   field.onChange(
//                                     e.target.value
//                                       .replace(/\D/g, "")
//                                       .slice(0, 4),
//                                   )
//                                 }
//                                 isInvalid={!!errors.cvc}
//                               />
//                             )}
//                           />
//                           {errors.cvc && (
//                             <div className="text-danger small">
//                               {errors.cvc.message}
//                             </div>
//                           )}
//                         </Form.Group>
//                       </Col>
//                       <Col md={4}>
//                         <Form.Group className="mb-3">
//                           <Form.Label className="required">ZIP CODE</Form.Label>
//                           <Controller
//                             name="zipCode"
//                             control={control}
//                             render={({ field }) => (
//                               <Form.Control
//                                 {...field}
//                                 placeholder="90210"
//                                 isInvalid={!!errors.zipCode}
//                               />
//                             )}
//                           />
//                           {errors.zipCode && (
//                             <div className="text-danger small">
//                               {errors.zipCode.message}
//                             </div>
//                           )}
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     <Row>
//                       <Col md={12}>
//                         <Form.Group className="mb-3">
//                           <Form.Label>ADDRESS</Form.Label>
//                           <Controller
//                             name="address"
//                             control={control}
//                             render={({ field }) => (
//                               <Form.Control
//                                 {...field}
//                                 placeholder="Enter address"
//                               />
//                             )}
//                           />
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     <Row>
//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Label className="required">
//                             INVOICE NUMBER
//                           </Form.Label>
//                           <Controller
//                             name="invoiceNumber"
//                             control={control}
//                             render={({ field }) => (
//                               <Form.Control
//                                 {...field}
//                                 type="text"
//                                 placeholder="Enter Invoice Number"
//                                 isInvalid={!!errors.invoiceNumber}
//                               />
//                             )}
//                           />
//                           {errors.invoiceNumber && (
//                             <div className="text-danger small">
//                               {errors.invoiceNumber.message}
//                             </div>
//                           )}
//                         </Form.Group>
//                       </Col>

//                       <Col md={6}>
//                         <Form.Group className="mb-3">
//                           <Form.Label className="required">AMOUNT</Form.Label>
//                           <InputGroup>
//                             <InputGroup.Text>
//                               <IconCurrencyDollar stroke={2} />
//                             </InputGroup.Text>
//                             <Controller
//                               name="amount"
//                               control={control}
//                               render={({ field }) => (
//                                 <Form.Control
//                                   {...field}
//                                   type="number"
//                                   step="0.01"
//                                   placeholder="Enter Amount"
//                                   min="0"
//                                   isInvalid={!!errors.amount}
//                                 />
//                               )}
//                             />
//                           </InputGroup>
//                           {errors.amount && (
//                             <div className="text-danger small">
//                               {errors.amount.message}
//                             </div>
//                           )}
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     <Row>
//                       <Col md={12}>
//                         <Form.Group className="mb-3">
//                           <Form.Label>ADDITIONAL NOTES</Form.Label>
//                           <Controller
//                             name="notes"
//                             control={control}
//                             render={({ field }) => (
//                               <Form.Control
//                                 {...field}
//                                 placeholder="Enter notes"
//                               />
//                             )}
//                           />
//                         </Form.Group>
//                       </Col>
//                     </Row>

//                     <div className="d-flex justify-content-center gap-3 mt-4">
//                       <Button
//                         type="button"
//                         variant="warning"
//                         disabled={isSubmitting}
//                         onClick={handleSubmit(onSubmit)}
//                       >
//                         {isSubmitting ? (
//                           <>
//                             <Spinner size="sm" /> Updating...
//                           </>
//                         ) : (
//                           "Update Card"
//                         )}
//                       </Button>
//                       <Button
//                         variant="outline-secondary"
//                         onClick={handleCancel}
//                       >
//                         Cancel
//                       </Button>
//                     </div>
//                   </Form>
//                 </FormProvider>
//               </Card.Body>
//             </Card>
//           </Col>
//         </Row>
//       </Modal.Body>
//     </Modal>
//   );
// }

// export default CustomerCardEdit;

import React, { useEffect, useState } from "react";
import {
  IconCreditCard,
  IconBrandVisa,
  IconCurrencyDollar,
} from "@tabler/icons-react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  Card,
  Button,
  Modal,
} from "react-bootstrap";
import { Controller, FormProvider, useForm } from "react-hook-form";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../constant/_constant";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { usePostHog } from "@posthog/react";

function CustomerCardEdit({ show, onClose, formData }) {
  const location = useLocation();
  const isCustomerList = location.pathname === "/customer-list";

  // Validation Schema — invoice & amount rules dropped when on /customer-list
  const validationSchema = Yup.object().shape({
    cardHolderName: Yup.string()
      .required("Cardholder name is required")
      .matches(/^[A-Za-z\s]+$/, "Only letters and spaces allowed"),
    cardNumber: Yup.string()
      .required("Card number is required")
      .matches(/^\d{15,16}$/, "Card number must be 15 or 16 digits"),
    expiry: Yup.string()
      .required("Expiry is required")
      .length(4, "Must be exactly 4 digits")
      .test("valid-expiry", "Invalid month (01-12)", (value) => {
        if (!/^\d{4}$/.test(value)) return false;
        const month = parseInt(value.slice(0, 2), 10);
        return month >= 1 && month <= 12;
      }),
    cvc: Yup.string()
      .nullable()
      .notRequired()
      .test("cvc-format", "CVC must be 3 or 4 digits", (value) => {
        if (!value) return true;
        return /^\d{3,4}$/.test(value);
      }),
    address: Yup.string().nullable().notRequired(),
    zipCode: Yup.string()
      .required("ZIP Code is required")
      .matches(/^\d{5,9}$/, "ZIP code must be 5–9 digits"),
    invoiceNumber: Yup.string().required("Invoice Number is required"),
    amount: Yup.number()
      .typeError("Amount must be a number")
      .required("Amount is required")
      .positive("Amount must be greater than zero"),
    notes: Yup.string().optional(),
  });

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    defaultValues: {
      cardHolderName: "",
      cardNumber: "",
      expiry: "",
      cvc: "",
      zipCode: "",
      invoiceNumber: "",
      amount: "",
      notes: "",
      address: "",
    },
  });

  useEffect(() => {
    if (show) {
      posthog.stopSessionRecording();
    } else {
      posthog.startSessionRecording();
    }
  }, [show]);

  const user = useSelector((state) => state.auth.user);
  const allowedRoles = ["finance"];
  const canViewFinancials = user?.roles?.some((role) =>
    allowedRoles.includes(role),
  );

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
    reset,
  } = methods;

  const { isLoading, postData: submitCardDetails } = usePostRequest(
    API_ENDPOINTS.UPDATE_CARD_DETAILS,
  );

  const posthog = usePostHog();
  const [cardId, setCardId] = useState(null);
  const [otp, setotp] = useState(null);

  useEffect(() => {
    if (show && formData) {
      setCardId(formData.id || null);
      setotp(formData.otp || null);
      setValue("cardHolderName", formData.data?.info_name || "");
      setValue("cardNumber", formData.data?.info_number || "");

      let expiry = formData.data?.info_expiry || "";
      if (expiry.includes("/")) {
        expiry = expiry.replace("/", "");
      }

      setValue("expiry", expiry);
      setValue("cvc", formData.data?.cvc_code || "");
      setValue("zipCode", formData?.data?.zip_code);
      setValue("invoiceNumber", formData.data?.invoice_number || "");
      setValue("amount", formData.data?.amount || "");
      setValue("notes", formData.data?.note || "");
      setValue("address", formData.data?.address || "");
    }
  }, [show, formData, setValue]);

  const handleCancel = () => {
    reset();
    onClose();
  };

  const onSubmit = (data) => {
    const apiData = {
      id: cardId,
      info_number: data.cardNumber.replace(/\D/g, ""),
      info_expiry: data.expiry.replace("/", ""),
      info_name: data.cardHolderName,
      cvc_code: data.cvc || null,
      otp: otp,
      zip_code: data.zipCode,
      // Send null / 0 when on customer-list, real values otherwise
      invoice_number: data.invoiceNumber,
      amount: data.amount,
      note: data.notes || null,
      address: data.address || null,
    };

    submitCardDetails(apiData, onSuccessApi, onErrorApi);
  };

  const onSuccessApi = (res) => {
    posthog.capture("payment_details_updated", {
      updated_by: user?.email,
    });
    toast.success(res?.message);
    onClose();
  };

  const onErrorApi = (err) => {
    toast.error(err?.message);
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      centered
      size="lg"
      scrollable
      dialogClassName="modal-90w"
    >
      <Modal.Header
        closeButton
        className="d-flex flex-column gap-2 justify-content-between pe-5 align-items-start"
      >
        <div className="d-flex align-items-center gap-2">
          <span className="avatar bg-indigo-lt rounded-circle">
            <IconCreditCard />
          </span>
          <Modal.Title>Update Customer Card Details</Modal.Title>
        </div>
        <p className="text-muted">
          You have 2 minutes to submit the form before the OTP expires.
        </p>
      </Modal.Header>

      <Modal.Body>
        <Row className="justify-content-center">
          <Col md={11}>
            <Card className="add_credit_card mb-3">
              <Card.Header className="card_header">UPDATE CARD</Card.Header>
              <Card.Body>
                <FormProvider {...methods}>
                  <Form>
                    <Row>
                      {/* Cardholder Name */}
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required">
                            CARDHOLDER NAME
                          </Form.Label>
                          <Controller
                            name="cardHolderName"
                            control={control}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                placeholder="Enter Cardholder Name"
                                isInvalid={!!errors.cardHolderName}
                              />
                            )}
                          />
                          {errors.cardHolderName && (
                            <div className="text-danger small">
                              {errors.cardHolderName.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      {/* Card Number */}
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required">
                            CARD NUMBER
                          </Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <IconBrandVisa stroke={1} />
                            </InputGroup.Text>
                            <Controller
                              name="cardNumber"
                              control={control}
                              render={({
                                field: { onChange, value, ...field },
                              }) => {
                                const digits = (value || "")
                                  .replace(/\D/g, "")
                                  .slice(0, 16);
                                const formatted = digits
                                  .replace(/(.{4})/g, "$1 ")
                                  .trim();
                                return (
                                  <Form.Control
                                    {...field}
                                    value={formatted}
                                    onChange={(e) =>
                                      onChange(
                                        e.target.value
                                          .replace(/\D/g, "")
                                          .slice(0, 16),
                                      )
                                    }
                                    placeholder="**** **** **** ****"
                                    isInvalid={!!errors.cardNumber}
                                  />
                                );
                              }}
                            />
                          </InputGroup>
                          {errors.cardNumber && (
                            <div className="text-danger small">
                              {errors.cardNumber.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      {/* Expiry */}
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required">EXPIRY</Form.Label>
                          <Controller
                            name="expiry"
                            control={control}
                            render={({
                              field: { onChange, value, ...field },
                            }) => {
                              const clean = (value || "")
                                .replace(/\D/g, "")
                                .slice(0, 4);
                              const formatted =
                                clean.length >= 3
                                  ? `${clean.slice(0, 2)}/${clean.slice(2)}`
                                  : clean;
                              return (
                                <Form.Control
                                  {...field}
                                  value={formatted}
                                  onChange={(e) =>
                                    onChange(
                                      e.target.value
                                        .replace(/\D/g, "")
                                        .slice(0, 4),
                                    )
                                  }
                                  placeholder="MM/YY"
                                  maxLength={5}
                                  isInvalid={!!errors.expiry}
                                />
                              );
                            }}
                          />
                          {errors.expiry && (
                            <div className="text-danger small">
                              {errors.expiry.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      {/* CVC */}
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>CVC CODE</Form.Label>
                          <Controller
                            name="cvc"
                            control={control}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type={canViewFinancials ? "text" : "password"}
                                placeholder="123"
                                maxLength={4}
                                onChange={(e) =>
                                  field.onChange(
                                    e.target.value
                                      .replace(/\D/g, "")
                                      .slice(0, 4),
                                  )
                                }
                                isInvalid={!!errors.cvc}
                              />
                            )}
                          />
                          {errors.cvc && (
                            <div className="text-danger small">
                              {errors.cvc.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      {/* ZIP Code */}
                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required">ZIP CODE</Form.Label>
                          <Controller
                            name="zipCode"
                            control={control}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                placeholder="90210"
                                isInvalid={!!errors.zipCode}
                              />
                            )}
                          />
                          {errors.zipCode && (
                            <div className="text-danger small">
                              {errors.zipCode.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Address */}
                    <Row>
                      <Col md={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>ADDRESS</Form.Label>
                          <Controller
                            name="address"
                            control={control}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                placeholder="Enter address"
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Invoice Number & Amount — hidden on /customer-list */}
                    {/* {!isCustomerList && ( */}
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required">
                            INVOICE NUMBER
                          </Form.Label>
                          <Controller
                            name="invoiceNumber"
                            control={control}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                type="text"
                                placeholder="Enter Invoice Number"
                                isInvalid={!!errors.invoiceNumber}
                              />
                            )}
                          />
                          {errors.invoiceNumber && (
                            <div className="text-danger small">
                              {errors.invoiceNumber.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="required">AMOUNT</Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <IconCurrencyDollar stroke={2} />
                            </InputGroup.Text>
                            <Controller
                              name="amount"
                              control={control}
                              render={({ field }) => (
                                <Form.Control
                                  {...field}
                                  type="number"
                                  step="0.01"
                                  placeholder="Enter Amount"
                                  min="0"
                                  isInvalid={!!errors.amount}
                                />
                              )}
                            />
                          </InputGroup>
                          {errors.amount && (
                            <div className="text-danger small">
                              {errors.amount.message}
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* Notes */}
                    <Row>
                      <Col md={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>ADDITIONAL NOTES</Form.Label>
                          <Controller
                            name="notes"
                            control={control}
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                placeholder="Enter notes"
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <div className="d-flex justify-content-center gap-3 mt-4">
                      <Button
                        type="button"
                        variant="warning"
                        disabled={isSubmitting}
                        onClick={handleSubmit(onSubmit)}
                      >
                        {isSubmitting ? (
                          <>
                            <Spinner size="sm" /> Updating...
                          </>
                        ) : (
                          "Update Card"
                        )}
                      </Button>
                      <Button
                        variant="outline-secondary"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </div>
                  </Form>
                </FormProvider>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default CustomerCardEdit;
